<template>
  <div>
    <headTop head-title='修改登录密码' go-back="true"></headTop>
    <div class="content">
      <ul class="ul" v-if="!showPwd">
        <li class="li">
          <span class="ic"></span>
          <input type="password" placeholder="请输入旧密码" maxlength="16" minlength="6" v-model="oldPwd">
          <!-- <i class="icon icon_delete" @click="getdDelete(1)"></i> -->
        </li>
        <li class="li">
          <span class="ic new"></span>
          <input type="password" placeholder="请输入新密码" maxlength="16" minlength="6" v-model="newPwd">
          <!-- <i class="icon icon_delete" @click="getdDelete(2)"></i> -->
        </li>
        <li class="li">
          <span class="ic new"></span>
          <input type="password" placeholder="再次输入新密码" maxlength="16" minlength="6" v-model="confirmPwd">
          <!-- <i class="icon icon_delete" @click="getdDelete(3)"></i> -->
        </li>
      </ul>
      <ul class="ul" v-if="showPwd">
        <li class="li">
          <span class="ic"></span>
          <input type="text" placeholder="请输入旧密码" maxlength="16" minlength="6" v-model="oldPwd"><i class="icon icon_delete" @click="getdDelete(1)"></i>
        </li>
        <li class="li">
          <span class="ic new"></span>
          <input type="text" placeholder="请输入新密码" maxlength="16" minlength="6" v-model="newPwd"><i class="icon icon_delete" @click="getdDelete(2)"></i>
        </li>
        <li class="li">
          <span class="ic new"></span>
          <input type="text" placeholder="再次输入新密码" maxlength="16" minlength="6" v-model="confirmPwd"><i class="icon icon_delete" @click="getdDelete(3)"></i>
        </li>
      </ul>
      <p @click="toggleShowPwd" class="show-pwd-btn">
        <span class="icon" :class="{'off': !this.showPwd}">✓</span>
        显示密码
      </p>
    </div>
    <div class="change-btn">
      <span class="btn" @click.stop.prevent='reset'>修改密码</span>
    </div>
  </div>
</template>

<script>
  import headTop from '@/components/common/header/head'
  import { userResource } from '@/resource/resource'

  const ERR_OK = 0

  export default {
    name: 'password',
    data () {
      return {
        oldPwd: '',
        newPwd: '',
        confirmPwd: '',
        showPwd: false
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
      toggleShowPwd() {
        this.showPwd = !this.showPwd
      },
      // 修改密码
      reset () {
        userResource.resetpwd({ old_pwd: this.oldPwd, new_pwd: this.newPwd, rep_pwd: this.confirmPwd }).then(response => {
          // success callback
          response = response.body
          if (response.errcode === ERR_OK) {
            this.$toast(response.errmsg)
            this.oldPwd = ''
            this.newPwd = ''
            this.confirmPwd = ''
            this.$router.push('/user/information')
          }
        })
      },
      // 清空密码
      getdDelete (val) {
        if (val === 1) {
          this.oldPwd = ''
        } else if (val === 2) {
          this.newPwd = ''
        } else if (val === 3) {
          this.confirmPwd = ''
        }
      }
    },
    components: {
      headTop
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~@/common/stylus/mixin";
.content
  margin-top 0.9rem
  font-size $font-size-l
  .ul
    // display flex
    // flex-direction column
    // padding-top 1rem
    .li
      // flex 1
      display flex
      background-color #ffffff
      height 0.96rem
      line-height 0.96rem
      border-bottom 1px solid #f4f4f4
      align-items center
      & > input
        outline none
        // padding-left 0.3rem
      .ic
        width 0.3rem
        height 0.3rem
        bg-image('old_pwd')
        background-size 0.3rem 0.3rem
        margin-left 0.28rem
        margin-right 0.24rem
        &.new
          bg-image('new_pwd')
      .icon
        margin 0.33rem 0.2rem
        width 0.3rem
        height 0.3rem
        display inline-block
        background-size cover
        &.icon_delete
          bg-image('icon_delete')
  .show-pwd-btn
    text-align right
    margin .3rem .3rem 0 0
    color $blue
    .icon
      vertical-align middle
      display inline-block
      border 1px solid $blue
      width .24rem
      height .24rem
      color $blue
      background transparent
      text-align center
      line-height .24rem
      font-size $font-size-m
      &.off
        color transparent
        border 1px solid #666666
.change-btn
  font-size $font-size-l
  padding 0 0.32rem
  text-align center
  .btn
    display inline-block
    height 0.8rem
    width 6.88rem
    margin-top 2.0rem
    color #ffffff
    line-height 0.8rem
    text-align center
    background-color $blue
    border-radius 0.1rem
</style>



// WEBPACK FOOTER //
// src/components/information/password/password.vue